import React, { Component } from 'react';
import Grid from '../../Utils/Grid';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/Grid/StandardActions';

class MonedaList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: true
    };

    componentDidMount = () => {
        const { listar, page } = this.props;
        listar(page);
    }
    render(){
        const { data, loader, eliminar, listar: onPageChange} = this.props;
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        return(
            <React.Fragment>
                <br />
                <h3 className="p-2 bg-secondary title">Monedas</h3>
                <br />
                <div className="d-flex flex-row justify-content-start mb-2">
                    { data.count <=1 &&
                        <a
                            href={`/#/ajustes/${id_emp[5]}/monedas/crear`}
                            className='btn btn-primary'
                        >
                            Crear moneda
                        </a>
                    }
                    <a
                        href={`/#/ajustes/${id_emp[5]}`}
                        className='btn btn-secondary ml-2'
                    >
                        Regresar
                    </a>
                </div>
                
                <div className="d-flex flex-row justify-content-start mb-2">
                    
                </div>
                
                {data &&
                    <Grid 
                        hover 
                        striped 
                        data={data} 
                        loading={loader} 
                        headerStyle={ { background: 'black' } } 
                        onPageChange={onPageChange}
                        //onSortChange={onSortChange} 
                    >
                        <TableHeaderColumn
                            isKey
                            dataField="moneda"
                            headerAlign="center"
                            dataAlign='left'
                            width="200"
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Moneda
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            thStyle={
                            {color: 'white'}}
                            dataField="id"
                            width="180"
                            dataAlign="center"
                            dataSort
                            dataFormat={standardActions({ 
                                editar: "monedas", 
                                ver: "monedas",
                                eliminar: eliminar })} 
                            
                        >
                            Acciones
                        </TableHeaderColumn>
                    </Grid>
                }
            </React.Fragment>
        );
    }
}

export default MonedaList;